<template>
  <RbuSectionItemPaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-rbut
    data-url="admin/rbu/item/"
    data-key="items"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    class="rbu-item-list"
  >
    <template #item.item_remark="{ value }">
      <div style="white-space: normal; word-wrap: break-word; max-width: 100%;">{{ value }}</div>
    </template>
    <template #item.need_manual_update="{ value }">
      <v-icon color="red" v-if="value">mdi-exclamation-thick</v-icon>
    </template>
    <template #item.manually_selected_rate="{ value, item }">
      <v-icon color="grey" v-if="value" @click="resetManuallySelected(item)"
        >mdi mdi-hand-back-left</v-icon
      >
    </template>
    <template #item.status="{ value }">
      <v-chip v-if="value === 'Pending'" color="orange" outlined>{{
        value
      }}</v-chip>
      <v-chip v-if="value === 'In Progress'" color="green" outlined>{{
        value
      }}</v-chip>
    </template>
    <template #item.last_user_save="{ value }">
      {{ value ? $parseDate(value, "yyyy-MM-dd HH:mm") : "-" }}
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <v-btn text color="primary" @click="editItem(item)"> More </v-btn>
        <v-btn
          text
          color="primary"
          v-if="
            $store.getters.hasPermission(PERMISSIONS.MANAGE_RBU_EDITION) &&
            canDeleteItem
          "
          @click="deleteItem(item)"
        >
          Delete
        </v-btn>
      </div>
    </template>
  </RbuSectionItemPaginatedList>
</template>

<script>
import { onMounted, ref, watch, computed } from "@vue/composition-api";
import RemotePaginatedList from "../RemotePaginatedList";
import RbuSectionItemPaginatedList from "../RbuSectionItemPaginatedList";
import { ACTION_TYPES } from "@/store/types";
import { PERMISSIONS, USER_TYPE } from "@/constants";

export default {
  name: "RbuItemList",
  components: { RemotePaginatedList, RbuSectionItemPaginatedList },
  props: {
    value: Array,
    refreshTrigger: Boolean,
  },
  setup(props, { root, emit }) {
    const innerRefreshTrigger = ref(false);

    const refresh = function () {
      innerRefreshTrigger.value = true;
    };

    const canDeleteItem = computed(() => {
      if (!root.$store.getters.account) return false;
      return [USER_TYPE.ADMIN, USER_TYPE.SUPER_ADMIN].includes(
        root.$store.getters.account.type
      );
    });

    onMounted(() => {
      refresh();
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );
    const parseRemark = function (value) {
      // Return full value for display
      return value;
    };

    // Filter
    const filterOptions = ref([
      {
        text: root.$t("rbu_item.previous_item_no"),
        value: "previous_item_no",
        contains: true,
      },
      {
        text: root.$t("rbu_item.dummy_item_no"),
        value: "dummy_item_no",
        contains: true,
      },
      {
        text: root.$t("rbu_item.current_item_no"),
        value: "current_item_no",
        contains: true,
      },
      {
        text: root.$t("rbu_item.need_manual_update"),
        value: "need_manual_update",
        options: [
          { text: "YES", value: true },
          { text: "NO", value: false },
        ],
      },
    ]);

    // Data Table
    const headers = ref([
      {
        text: root.$t("rbu_item.previous_item_no"),
        value: "previous_item_no",
      },
      {
        text: root.$t("rbu_item.dummy_item_no"),
        value: "dummy_item_no",
      },
      {
        text: root.$t("rbu_item.current_item_no"),
        value: "current_item_no",
      },
      {
        text: root.$t("rbu_item.item_remark"),
        value: "item_remark",
        width: "30%",
        cellClass: "remark-cell",
      },
      {
        text: root.$t("rbu_item.need_manual_update"),
        value: "need_manual_update",
      },
      {
        text: root.$t("rbu_item.manually_selected_rate"),
        value: "manually_selected_rate",
      },
      {
        text: root.$t("rbu_item.status"),
        value: "status",
      },
      {
        text: root.$t("rbu_item.last_update_date"),
        value: "last_user_save",
      },
      // {text: root.$t('rbu_item.rank'), value: 'rank'},
      { text: "", value: "actions", sortable: false, width: 100 },
    ]);

    const editItem = async function (item) {
      root.$router.push({ name: "rbu-item", params: { itemId: item.id } });
    };
    const deleteItem = async function (item) {
      if (
        await root.$dialog.confirm({
          text: `Delete RBU Item - ${item.dummy_item_no} ?`,
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/item/delete/",
          params: { item_id: item.id },
        });

        await refresh();
        emit("update:refresh-mapping-trigger", true);
      }
    };

    const resetManuallySelected = async (item) => {
      const confirmReset = await root.$dialog.confirm({
        text: "Are you sure to disable the Manually Selected Rate? (Yes/No)",
        title: "Confirm Reset",
      });
      if (confirmReset) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/item/reset_selected_adopted_rate_type/",
          params: { item_id: item.id },
        });

        await refresh();
      }
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,

      editItem,
      deleteItem,

      PERMISSIONS,
      parseRemark,

      resetManuallySelected,
      canDeleteItem,
    };
  },
};
</script>

<style lang="less" scoped>
.rbu-item-list ::v-deep {
  .remark-cell {
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
    max-width: 100% !important;
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
  
  td.remark-cell {
    height: auto !important;
    min-height: 48px !important;
  }
}
</style>
